module.exports = __webpack_public_path__ + "static/media/cicek3.b91d939b.jpg";